import React from "react";
import { useMediaQuery } from "../../utils";
import { FONT_SIZES } from "../../styles";

const AboutMe = () => {
  const isMobile = useMediaQuery();

  return (
    <div style={{ fontSize: isMobile ? FONT_SIZES.xs : FONT_SIZES.s }}>
      <div style={{ marginBottom: "4vh" }}>
        🚀 Houston based full-stack software engineer with 6+ years experience
      </div>
      <div style={{ marginBottom: "4vh" }}>
        🎼 Former music educator turned mobile app developer turned Googler
      </div>
      <div style={{ marginBottom: "4vh" }}>
        💻 Likes architecting, implementing, and optimizing systems
      </div>
    </div>
  );
};
export default AboutMe;
